import script from "./CrmLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./CrmLayout.vue?vue&type=script&setup=true&lang=js"

import "./CrmLayout.vue?vue&type=style&index=0&id=28806802&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28806802"]])

export default __exports__